import { ReactNode } from 'react';

type CmsWorkyInfoProps = { heading: string; children: ReactNode };
export const CmsWorkyInfo = ({ heading, children }: CmsWorkyInfoProps): JSX.Element => (
	<>
		<h1>{heading}</h1>
		<div id="info-grid">{children}</div>
	</>
);
